export default __webpack_public_path__ + "static/media/25.84ff9339.svg";